// Decodes the base64 `payload` attribute that outreach tool-result widgets
// carry. Tools emit :::widget[X]{payload="<base64 of JSON>"}::: — base64
// avoids the normalizer's `[^}]*` truncation (JSON braces) and rehype-sanitize
// quote issues. Returns {} on any failure so widgets fall back to empty state.
export function decodeWidgetData(payload: unknown): Record<string, unknown> {
  if (typeof payload !== 'string' || payload.length === 0) return {};
  try {
    // atob handles standard base64 (incl. +/=). The directive attribute
    // value is double-quoted so +/= survive the parser.
    return JSON.parse(atob(payload)) as Record<string, unknown>;
  } catch {
    return {};
  }
}
